let iconPath = "https://cdn.jsdelivr.net/npm/@trendyol/baklava-icons@latest/icons";

export function setIconPath(path: string) {
  iconPath = path;
}

export function getIconPath() {
  return iconPath;
}
